export var IdTooltipAnchor;
(function (IdTooltipAnchor) {
    IdTooltipAnchor["Top"] = "top";
    IdTooltipAnchor["Bottom"] = "bottom";
    IdTooltipAnchor["Right"] = "right";
    IdTooltipAnchor["Left"] = "left";
    IdTooltipAnchor["TopLeft"] = "top-left";
    IdTooltipAnchor["TopRight"] = "top-right";
    IdTooltipAnchor["BottomLeft"] = "bottom-left";
    IdTooltipAnchor["BottomRight"] = "bottom-right";
})(IdTooltipAnchor || (IdTooltipAnchor = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/tooltip/IdTooltipAnchor.ts
// module id = 322
// module chunks = 3